import { IFT_UPDATE_PRE_BOOKED_CHECKED } from '../ift/actions';
import { initialState } from './common';
import { RESET_APP } from '../page/actions';

export const IFTHandlers = {
	[RESET_APP]: (state) => ({ paymentType: state.paymentType }),
	[IFT_UPDATE_PRE_BOOKED_CHECKED]: (state, action) => {
		if (action.isPreBooked) {
			return {
				...state,
				iftPaymentDetails: {
					...state.iftPaymentDetails,
					preBookedReference: { ...initialState },
					preBookedRate: { ...initialState },
				},
			};
		}
		const {
			iftPaymentDetails: { preBookedReference, preBookedRate, ...newBlock },
		} = state;
		return {
			...state,
			iftPaymentDetails: newBlock,
		};
	},
};
